import CustomImage from "./CustomImage";

/**
 * SmartImage: SVG ise otomatik olarak unoptimized kullanır
 * - src string değilse (ör: imported React component) doğrudan NextImage'e paslar
 * - src string ve .svg ile bitiyorsa `unoptimized`=true ekler
 *   (böylece /_next/image endpointine gitmez, direkt served)
 */
export default function SmartImage(props) {
  const { src } = props;
  if (typeof src === "string" && src.endsWith(".svg")) {
    // width/height yoksa Next <Image> uyarı verir; caller sağlamalı.
    return <CustomImage {...props} unoptimized />;
  }
  return <CustomImage {...props} />;
}
